






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class CarrierProductDetailAdditional extends Vue {
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProduct!: CarrierProduct
}
